function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { makeStyles, IconButton } from '@applyboard/ui-components';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { BackIcon } from "../../../../assets/images";
import { getApplication } from "../../../../store/Selectors";
import { countries, isPreferenceQuestionPath, Keys, Routes } from "../../Common/Constants";
import useCefNavigation from "../../Hooks/useCefNavigation";
import { pages } from "../../../controller/consts";
import { useAppContext } from "../../Providers";
import { isFromApplyBoostCountry } from "../../Utilities/Validators";
import { useApplyBoostCountries } from "../../../../data/applyBoostCountry";
var useStyles = makeStyles({
  backButton: {
    '&.MuiIconButton-root': {
      "float": 'left',
      padding: 0
    }
  }
});
var BackButton = function BackButton(_ref) {
  var nationality = _ref.nationality,
    countryOfResidence = _ref.countryOfResidence;
  var classes = useStyles();
  var location = useLocation();
  var navigate = useCefNavigation();
  var _useAppContext = useAppContext(),
    onboardingMode = _useAppContext.onboardingMode;
  var _useApplyBoostCountri = useApplyBoostCountries(),
    applyBoostCountriesData = _useApplyBoostCountri.applyBoostCountriesData,
    isApplyBoostCountriesLoading = _useApplyBoostCountri.isApplyBoostCountriesLoading;
  var applyBoostCountriesByCode = applyBoostCountriesData.map(function (country) {
    return country.code;
  });
  var isStudentOfApplyBoost = isFromApplyBoostCountry(nationality, countryOfResidence, applyBoostCountriesByCode);
  if (isApplyBoostCountriesLoading) {
    return null;
  }
  var handleClick = function handleClick() {
    var pathname = location.pathname;
    // if we're currently on a preference question, go to the previous one.
    // the first question (first name) does not have a back button, so we can ignore that case
    if (isPreferenceQuestionPath(pathname)) {
      var orderedPreferencePages = Object.values(Routes.Preferences);
      var _currentPageIndex = orderedPreferencePages.indexOf(pathname);
      var _previousPage = orderedPreferencePages[_currentPageIndex - 1];
      navigate(_previousPage);
      return;
    }
    // if CEF page 1 and we started with preference questions, go to last preference question
    if (pathname === Routes.Eligibility.NationalityQuestion && onboardingMode) {
      var lastPreferenceQuestionPage = Object.keys(pages).find(function (page) {
        return pages[page].nextPage === Routes.Eligibility.NationalityQuestion;
      });
      navigate(lastPreferenceQuestionPage);
      return;
    }
    if (pathname === Routes.Eligibility.ProvinceOfResidenceQuestion) {
      navigate(Routes.Eligibility.NationalityQuestion);
      return;
    }

    // if CEF page 4 and non-indian resident, go to page 2 (page 3 is province of residency)
    if (pathname === Routes.Eligibility.HighestEducationQuestion && countryOfResidence !== null && countryOfResidence !== void 0 && countryOfResidence.code && (countryOfResidence === null || countryOfResidence === void 0 ? void 0 : countryOfResidence.code) !== countries.India.code) {
      navigate(Routes.Eligibility.NationalityQuestion);
      return;
    }
    if (pathname === Routes.ApplyBoost.AdvisorConfirmationPage && isStudentOfApplyBoost) {
      var nextRoute = Routes.ApplyBoost.PathwayPage;
      navigate(nextRoute);
      return;
    }

    // in the general CEF case, go to previous CEF page
    var orderedEligibilityPages = Object.values(Routes.Eligibility);
    var currentPageIndex = orderedEligibilityPages.indexOf(pathname);
    var previousPage = orderedEligibilityPages[currentPageIndex - 1];
    navigate(previousPage);
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "go back",
    className: classes.backButton,
    onClick: function onClick() {
      return handleClick();
    }
  }, /*#__PURE__*/React.createElement(BackIcon, null)));
};
var mapStateToProps = function mapStateToProps(state) {
  var _ref2;
  var application = getApplication(state);
  return _ref2 = {}, _defineProperty(_ref2, Keys.Application.nationality, application.nationality), _defineProperty(_ref2, Keys.Application.countryOfResidence, application.countryOfResidence), _ref2;
};
export default connect(mapStateToProps)(BackButton);